import { Grid, Theme, useMediaQuery } from '@mui/material';
import OrderList from 'components/molecules/m-order-list';
import renderIcon from 'icon';
import React, { useState } from 'react';
import { IoArrowBackCircleSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { CompletedIcon, OngoingIcon } from '../../../assets/Icons';
import { CustomTab, CustomTabs, TabPanel, a11yProps } from '../../../components/molecules';
import { HeaderCON } from '../styles';

export const UserOrders = () => {
  const navigate = useNavigate();
  const [currentRoute, setCurrentRoute] = useState(0);
  const lg = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const handleChange = (_: React.SyntheticEvent<Element, Event>, value: any) => {
    setCurrentRoute(value);
  };

  return (
    <>
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
        {renderIcon(IoArrowBackCircleSharp, {
          size: 24,
          className: 'text-black flex-shrink-0 cursor-pointer hover:text-gray-600 transition-colors',
          onClick: () => navigate('/account')
        })}
        <span
          className="font-semibold"
          style={{ color: '#222', cursor: 'pointer' }}
          onClick={() => navigate('/account')}>
          Account
        </span>
        <span>›</span>
        <span className="font-semibold" style={{ color: '#222' }}>
          Orders
        </span>
      </div>
      {!lg && <HeaderCON>Orders History</HeaderCON>}
      <Grid container gap={'33px'}>
        <Grid xs={12} lg={3.5} item>
          <CustomTabs
            value={currentRoute}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            orientation={lg ? 'horizontal' : 'vertical'}>
            <CustomTab
              label={lg ? 'All' : 'All Orders'}
              {...a11yProps(0)}
              disableRipple
              icon={<OngoingIcon />}
              iconPosition="start"
            />
            <CustomTab
              label={lg ? 'Ongoing' : 'Ongoing Orders'}
              {...a11yProps(1)}
              disableRipple
              icon={<OngoingIcon />}
              iconPosition="start"
            />
            <CustomTab
              label={lg ? 'Completed' : 'Completed Orders'}
              {...a11yProps(2)}
              disableRipple
              icon={<CompletedIcon />}
              iconPosition="start"
            />
            <CustomTab
              label={lg ? 'Recurring' : 'Recurring Orders'}
              {...a11yProps(2)}
              disableRipple
              icon={<CompletedIcon />}
              iconPosition="start"
            />
            {/* <CustomTab
              label={lg ? 'Cancelled' : 'Cancelled Orders'}
              {...a11yProps(3)}
              disableRipple
              icon={<ClipboardIcon />}
              iconPosition="start"
            /> */}
          </CustomTabs>
        </Grid>

        <Grid xs={12} lg={7.7} item>
          <TabPanel value={currentRoute} index={0}>
            <OrderList variant="ALL" noneMessage="No Orders found" />
          </TabPanel>

          <TabPanel value={currentRoute} index={1}>
            <OrderList variant="ONGOING" noneMessage="No Ongoing Orders found" />
          </TabPanel>

          <TabPanel value={currentRoute} index={2}>
            <OrderList variant="COMPLETE" noneMessage="No Completed Orders found" />
          </TabPanel>
          <TabPanel value={currentRoute} index={3}>
            <OrderList variant="RECURRING" noneMessage="No Recurring Orders found" />
          </TabPanel>

          {/* <TabPanel value={currentRoute} index={3}>
            <OrderList variant="canceled" noneMessage="No Cancelled Orders found" />
          </TabPanel> */}
        </Grid>
      </Grid>
    </>
  );
};
